import React from 'react';
// import {HomeOutlined} from '@ant-design/icons';
import {Breadcrumb, Col, Layout, Menu, Row, theme,Image} from "antd";
import {useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {RiBrainLine, RiDatabaseLine, RiEarthLine, RiHome5Line, RiMickeyLine, RiTeamLine} from "@remixicon/react";
// import Sider from "antd/es/layout/Sider";
const {Header, Content ,Sider} = Layout;

const MiroProteomeHome=()=>{
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [shouldRenderOtherComponents,setShouldRenderOtherComponents]=useState(false)
    const location = useLocation();
    useEffect(()=>{
        setShouldRenderOtherComponents(location.pathname.startsWith('/miroProteome/home'))
    },[location.pathname])

    return (

        <div>
            {shouldRenderOtherComponents && (
                <>
                    <Row>
                        <Col span={5}>
                            <Image style={{ padding: '10px 0px 10px 20px'}}
                                   src={require('../../assets/logo-chem1.png')}
                            />
                        </Col>
                        <Col span={19}>
                            <Content style={{  fontWeight: 'bold',padding: '12px 24px',fontSize:'24px',fontFamily:'Arial'}}>
                                Welcome to MiroProteome!
                            </Content>
                            <Content style={{ padding: '0 24px',fontSize:'20px',fontFamily:'Arial'}}>
                                Here we provide whole-cell proteomic data across cell lines and models, with or without modulating MIRO1. Mean MS values are shown and expressed as heat maps. Please refer to the original papers for exact values of each replicates as some replicates have missing values.
                            </Content>
                            <Content style={{ fontWeight: 'bold',padding: '24px 24px 6px 24px',fontSize:'20px',fontFamily:'Arial'}}>
                                If using MiroScape or the data provided, please cite:
                            </Content>
                            <Content style={{ padding: '0 24px', fontSize: '18px', fontFamily: 'Arial' }}>
                                Du, Z.*; Li, M.-H.*; Bergsneider, B. H.; Tsai, A. P.; Cho, K. B.; Kim, L. H.; Choi, J.; Li, G.; Wyss-Coray, T.; Lim, M.; Wang, X. (2026). Cross-species transcriptomic integration reveals a MIRO1-mediated macrophage-T cell axis in glioma. <i>Life Science Alliance</i> 9(8): e202603749. doi:{' '}
                                <a
                                    href="https://doi.org/10.26508/lsa.202603749"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://doi.org/10.26508/lsa.202603749
                                </a>
                            </Content>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
}
export default MiroProteomeHome;